export default __webpack_public_path__ + "static/media/fools.48743fd1.png";